/* HouseGap's icon set: glass renders generated with Higgsfield (GPT Image 2.5,
   transparent background) from three sheets in public/img/src/icons/, sliced
   into 128px WebP files in public/img/icons/. One sheet set the style and
   the other two were generated against it as a reference, so all 24 match.
   Every icon is decorative: the label next to it carries the meaning. */

export const ICON_NAMES = [
  'overview', 'casinos', 'wallets', 'chains', 'compare', 'reports', 'sources',
  'coins', 'gap', 'flow', 'star', 'trophy', 'grid', 'steps', 'trend', 'clock',
  'rings', 'pulse', 'warning', 'shield', 'calendar', 'globe', 'search', 'info',
] as const;
export type IconName = (typeof ICON_NAMES)[number];

export function Icon({ name, size = 20, className }: { name: IconName; size?: number; className?: string }) {
  return (
    <img className={`gicon${className ? ` ${className}` : ''}`} src={`/img/icons/${name}.webp`}
      width={size} height={size} alt="" aria-hidden draggable={false} decoding="async" />
  );
}
